import { useQuery } from '@tanstack/react-query';
import {
  UserKeys,
  betaGetGmailVacationMessage,
} from '../../../../../api/users-api';
import VacationResponderForm from './vacation-responder-form';
import { useUserSettings } from '../../../../../utils/use-user-settings';
import { useParams } from 'react-router-dom';
import { Messages } from '../../../../../utils/message-constants';

import Card from '@mui/material/Card';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';

export default function VacationResponderPage() {
  const { userEmail } = useParams() as { userEmail: string };
  const { userRoles, changeLogRoles } = useUserSettings();

  const {
    data: vacationMessage,
    isFetching,
    isLoading,
  } = useQuery({
    queryKey: [UserKeys.VacationMessage, userEmail],
    queryFn: () => betaGetGmailVacationMessage(userEmail),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('vacation responder'),
    },
  });

  if (isLoading || isFetching) {
    return (
      <Card
        sx={{
          height: '100%',
        }}
      >
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{ width: '100%', minHeight: '100%' }}
        >
          <CircularProgress />
        </Stack>
      </Card>
    );
  }

  if (vacationMessage) {
    return (
      <VacationResponderForm
        userEmail={userEmail}
        userRoles={userRoles}
        vacationMessage={vacationMessage}
        changeLogRoles={changeLogRoles}
      />
    );
  }
}
